import { Config } from 'scenes/common/types';
import { ReduxAction } from './configReducer';
import { ConfigActions } from './configTypes';

export const updateConfig = (configData: Partial<Config>): ReduxAction => ({
  type: ConfigActions.UPDATE_CONFIG,
  payload: configData,
});

export const resetConfig = (): ReduxAction => ({
  type: ConfigActions.RESET_CONFIG,
  payload: {},
});
